<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="12" md="6" lg="4">
      <FilterSearch
        :label="$t('search')"
        :fetchData="listServiceProviders"
        inner-icon="mdi-magnify"
      />
    </v-col>
  </v-row>
</template>

<script>
import FilterSearch from '@/components/filters/FilterSearch'
import { mapActions } from 'vuex'

export default {
  name: 'ServiceProviderFilters',
  components: { FilterSearch },
  methods: {
    ...mapActions(['listServiceProviders']),
  },
}
</script>
